// extracted by mini-css-extract-plugin
export default {"input":"MaskedInput_input__-shqb","label":"MaskedInput_label__7xi0u"};